import React from 'react';
import './HomeBanner.css';

const HomeBanner = () => (
    <section className="banner" style={{ backgroundImage: `url(${process.env.PUBLIC_URL + '/assets/banner-bg.png'})` }}>
        <div className="container">
            <div className="row">
                <div className="col-11">
                    <h2>First Love? <span>Nah… First Scoop.</span></h2>
                    <h5>That first spoon of Kwality? Magic. Pure, creamy,<br />nostalgic magic.</h5>
                    <p className="btn"><a href="">Pickup Now <i className="fas fa-angle-double-right"></i></a></p>
                    <small>Euless - Available</small>
                </div>
            </div>
        </div>
        <div className="image">
            <img src={process.env.PUBLIC_URL + '/assets/banner-img-1.png'} className="img" alt="" />
            <img src={process.env.PUBLIC_URL + '/assets/banner-img-2.png'} className="img1" alt="" />
        </div>
        <div className="image-mobile">
            <img src={process.env.PUBLIC_URL + '/assets/banner-mobile-img-1.png'} className="img" alt="" />
            <img src={process.env.PUBLIC_URL + '/assets/banner-mobile-img-2.png'} className="img1" alt="" />
        </div>
    </section>
);

export default HomeBanner; 